/* eslint-disable no-console */
import React, { useMemo } from 'react'
import type { HeadingLevel } from 'src/typings/headingTags'
import { useSession } from 'src/sdk/session'
import { useProductsQuery } from 'src/sdk/product/useProductsQuery'
import { useInView } from 'react-intersection-observer'
import DynamicHeadingTags from 'src/components/common/DynamicHeadingTags/DynamicHeadingTags'
import InsiderCartDefaultCard from './InsiderCartDefaultCard'
import '../shelf-minicart.scss'

type Props = {
  insiderShelfTitle: string
  headingTitle: HeadingLevel
  fontfamily: string
  collectionId: string
  itemsToDisplay: number
}

function InsiderCartDefaultShelf({
  insiderShelfTitle,
  collectionId,
  headingTitle,
  fontfamily,
  itemsToDisplay
}: Props) {

  const { ref } = useInView({
    triggerOnce: true,
    threshold: 0.75,
  })

  const { channel } = useSession()

  if (!channel) {
    throw new Error(`useProduct: 'channel' from session is an empty string.`)
  }

  const productList = useProductsQuery({
    first: 12,
    after: '',
    sort: 'score_desc',
    term: '',
    selectedFacets: [
      { key: 'productClusterIds', value: collectionId },
      { key: 'channel', value: channel },
    ],
  })

  const products = useMemo(
    () => productList?.edges?.map((edge) => edge.node) ?? [],
    [productList]
  )

  if(!products?.length){
    return null
  }

  return (
    <section className="insider-shelf-minicart">
      <div className="shelf-header--minicart">
        <DynamicHeadingTags
          className="insider-shelf__title--minicart"
          as={headingTitle}
          style={{
            fontFamily: fontfamily === '2' ? 'roboto' : 'Cormorant Garamond',
          }}
        >
          {insiderShelfTitle}
        </DynamicHeadingTags>
      </div>

      <div className={`insider-shelf__slider `} ref={ref}>
        {products.length > 0 && (
          <>
            {products.slice(0, itemsToDisplay).map((product, idx) => (
              <InsiderCartDefaultCard
                key={product.id}
                product={product}
                index={idx}
              />
            ))}
          </>
        )}
      </div>
    </section>
  )
}

export default InsiderCartDefaultShelf
